(() => {
  const sectionIdFor = element => {
    const section = element?.closest('[id^="shopify-section-"]');
    return section?.id.replace(/^shopify-section-/, '') || '';
  };

  const renderSection = async (current, selector) => {
    const sectionId = sectionIdFor(current);
    if (!sectionId) return false;

    const url = new URL(window.location.href);
url.searchParams.delete('section_id');
url.searchParams.set('sections', sectionId);
url.searchParams.set('_talent_cart_refresh', Date.now().toString());

// No Accept: application/json here: on /collections/* Shopify answers that with an empty 404.
const response = await fetch(url.toString(), {
  cache: 'no-store',
  credentials: 'same-origin'
});

    if (!response.ok) throw new Error('Unable to refresh the cart.');

    const sections = await response.json();
    const html = sections[sectionId];
    if (!html) return false;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector(selector);
    if (!fresh) return false;

// Empty and filled carts use different drawer layouts outside the update regions, so when the
// layout changes (e.g. the first item added) swap the whole drawer, or the empty state flashes.
const layout = el => el.querySelector('.xo-modal-content__inner')?.className || '';
if (layout(current) !== layout(fresh)) {
  // Keep the free-gift app's banner (Monk injects it into the drawer body and won't re-add it).
  const gift = current.querySelector('#mr-div-embedded-banner-cart-drawer');
  current.innerHTML = fresh.innerHTML;
  if (gift) current.querySelector('.xo-modal-content__body')?.append(gift);
  return true;
}

const regions = [
  ...current.querySelectorAll('xo-cart-will-change')
];
const freshRegions = [
  ...fresh.querySelectorAll('xo-cart-will-change')
];

if (!regions.length) {
  current.innerHTML = fresh.innerHTML;
  return true;
}

const pairs = regions.map((region, index) => {
  const uid = region.getAttribute('xo-unique-id');
  const replacement = uid
    ? freshRegions.find(
        candidate => candidate.getAttribute('xo-unique-id') === uid
      )
    : freshRegions[index];

  return { region, replacement };
});

if (pairs.some(pair => !pair.replacement)) {
  throw new Error('Unable to find updated cart content.');
}

pairs.forEach(({ region, replacement }) => {
  region.innerHTML = replacement.innerHTML;

  [...replacement.attributes].forEach(attribute => {
    region.setAttribute(attribute.name, attribute.value);
  });
});

return true;

  };

  const updateCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;

    const cart = await response.json();
    document.querySelectorAll('xo-cart-size').forEach(count => {
      count.textContent = cart.item_count;
    });
  };

  const openDrawer = () => {
    if (window.location.pathname.endsWith('/cart')) return;

    const modal = document.querySelector('xo-modal[xo-name="cart"]');
    if (modal?.hasAttribute('xo-active')) return;

    const trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (trigger) {
      if (customElements.get('xo-modal-trigger')) {
        trigger.click();
      } else {
        customElements.whenDefined('xo-modal-trigger')
          .then(() => trigger.click());
      }
      return;
    }

    const fallbackTrigger = document.createElement('xo-modal-trigger');
    fallbackTrigger.setAttribute('xo-name', 'cart');
    fallbackTrigger.hidden = true;
    document.body.append(fallbackTrigger);

    customElements.whenDefined('xo-modal-trigger').then(() => {
      fallbackTrigger.click();
      fallbackTrigger.remove();
    });
  };

  const refresh = async ({ open = true } = {}) => {
    const drawer = document.querySelector('xo-cart-mini#xo-cart-mini');
    const cartPage = document.querySelector('xo-cart');
    const jobs = [updateCartCount()];

    if (drawer) {
      jobs.push(renderSection(drawer, 'xo-cart-mini#xo-cart-mini'));
    }

    if (cartPage) {
      jobs.push(renderSection(cartPage, 'xo-cart'));
    }

    await Promise.allSettled(jobs);
    if (open && drawer) openDrawer();

    document.dispatchEvent(new CustomEvent('talent:cart-refreshed'));
  };

  const handleRefresh = event => {
    refresh({ open: event.detail?.open !== false });
  };

  window.TalentCart = { refresh, open: openDrawer };
  document.addEventListener('cart:refresh', handleRefresh, true);
})();
